import ConfirmationModal from "../../../components/ConfirmationModal";

const DeleteTransferConfirmationModal = ({ show, onClose, onDelete }) => (
  <ConfirmationModal
    show={show}
    title="Are you sure you want to delete this transfer?"
    description="The transfer and its pricing are removed from the quotation."
    variant="danger"
    confirmLabel="Delete"
    onCancel={onClose}
    onConfirm={onDelete}
  />
);

export default DeleteTransferConfirmationModal;
